import {Injectable, OnInit} from '@angular/core';
import {RestService} from "./rest/rest.service";
import {FormGroup, ValidatorFn} from "@angular/forms";
import {LevenshteinConfiguration} from "../admin/admin-levenshtein-config/levenshtein-configuration";
import levenshtein from 'js-levenshtein';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LevenshteinValidatorService implements OnInit {

  constructor(private restService: RestService) {}

  private config: LevenshteinConfiguration;

  public initialized: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  ngOnInit(): void {
    this.init();
  }

  public init() {
    return this.restService.getLevenshteinConfigUnsecured().subscribe(value => {
      this.config = value;
    }, error => {
      console.warn("Unable to get levenshtein config!");
      this.config = new LevenshteinConfiguration();
    }, () => this.initialized.next(true));
  }

  //remember to init function first!
  public passwordLevenshteinValidator: ValidatorFn = (fg: FormGroup) => {
    let levenshteinDiff = this.config.diff;
    if (levenshteinDiff > 0) {
      const start = fg.get('password').value;
      const end = fg.get('passwordold').value;
      return start !== null && end !== null && levenshtein(start, end) >= levenshteinDiff
        ? null
        : {
          levenshteinError: true,
          levenshteinExpDiff: levenshteinDiff,
          levenshteinDiff: levenshtein(start, end)
        };
    }

    return null;
  }
}
